import {
  createDocument,
  getIsDocumentExists,
  updateDocument
} from 'services/api/firebase'

/**
 * If the data is not null, check if the document exists, if it does, update it, if it doesn't, create
 * it
 * @param collection - The collection name
 * @param data - The data that you want to save.
 * @returns The id of the document that was created or updated.
 */
const saveBelongsToRelationship = async (
  collection,
  data,
  additionalData = {},
  _id
) => {
  if (!data) return null
  else {
    const isDocumentExists = await getIsDocumentExists(collection, data._id)
    if (isDocumentExists) {
      await updateDocument(collection, data._id, {
        ...data,
        ...additionalData
      })
      return data._id
    } else {
      const { _id } = await createDocument(
        collection,
        {
          ...data,
          ...additionalData
        },
        data._id
      )
      return _id
    }
  }
}

export default saveBelongsToRelationship
